import travelimg from '../asset/projects/travel.webp';
import constructionimg from '../asset/projects/dummy_construction.webp';
import construction2 from '../asset/projects/construction2.jpg';
import architecture from '../asset/projects/architecture.jpg';
import architecture2 from '../asset/projects/architecture2.jpg';
import solar from '../asset/projects/solar.jpg';
import daycare from '../asset/projects/daycare.jpg';

export const projectsData = [
  {
    id: 1,
    slug: 'travel-website',
    title: 'Travel Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A modern travel and tourism website designed to inspire exploration with stunning destination showcases, seamless booking experiences, and interactive tour packages. Built with a focus on user engagement, smooth navigation, and immersive visual storytelling.',
    tags: ['React', 'Node.js', 'E-commerce', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: travelimg,
    stats: { metric1: '150%', label1: 'Traffic Increase', metric2: '4.8/5', label2: 'User Rating' },
  },
  {
    id: 2,
    slug: 'construction-website',
    title: 'Construction Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A professional construction company website featuring modern project galleries, detailed service sections, and strong brand presentation. Built with a focus on credibility, performance, and generating client inquiries through a clean and trustworthy design.',
    tags: ['React', 'Node.js', 'E-commerce', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: constructionimg,
    stats: { metric1: '150%', label1: 'Traffic Increase', metric2: '4.8/5', label2: 'User Rating' },
  },
  {
    id: 3,
    slug: 'construction-company-website',
    title: 'Construction Company Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A second construction industry build focused on showcasing completed projects, service capabilities, and client testimonials with a bold, results-driven layout.',
    tags: ['React', 'Node.js', 'CMS', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: construction2,
    stats: { metric1: '120%', label1: 'Lead Growth', metric2: '4.7/5', label2: 'User Rating' },
  },
  {
    id: 4,
    slug: 'architecture-studio-website',
    title: 'Architecture Studio Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'An elegant portfolio website for an architecture studio, featuring full-bleed project galleries, smooth scroll transitions, and a minimalist design language that lets the work speak for itself.',
    tags: ['React', 'Node.js', 'Portfolio', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: architecture,
    stats: { metric1: '135%', label1: 'Traffic Increase', metric2: '4.9/5', label2: 'User Rating' },
  },
  {
    id: 5,
    slug: 'modern-architecture-firm',
    title: 'Modern Architecture Firm',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A sleek, image-forward website for a modern architecture firm, designed to highlight residential and commercial projects with immersive case study pages.',
    tags: ['React', 'Node.js', 'Portfolio', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: architecture2,
    stats: { metric1: '140%', label1: 'Traffic Increase', metric2: '4.8/5', label2: 'User Rating' },
  },
  {
    id: 6,
    slug: 'kids-daycare-website',
    title: 'Kids Daycare Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A warm and friendly website for a kids daycare center, featuring program details, enrollment forms, and a gallery designed to build trust with parents.',
    tags: ['React', 'Node.js', 'CMS', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: daycare,
    stats: { metric1: '110%', label1: 'Enrollment Inquiries', metric2: '5.0/5', label2: 'User Rating' },
  },
  {
    id: 7,
    slug: 'solar-energy-website',
    title: 'Solar Energy Website',
    category: 'Web Development',
    categorySlug: 'custom-web-development',
    description:
      'A conversion-focused website for a solar energy provider, featuring savings calculators, service area maps, and a streamlined quote request flow.',
    tags: ['React', 'Node.js', 'E-commerce', 'GSAP'],
    color: '#8b4513',
    iconId: 'shop',
    image: solar,
    stats: { metric1: '160%', label1: 'Quote Requests', metric2: '4.9/5', label2: 'User Rating' },
  },
];

export const categories = [
  'All',
  'Cloud Solutions',
  'Web Development',
  'App Development',
  'AI & ML',
  'SEO',
  'WordPress',
];